export const ShapeDividerBuilderID = '88110a9d-ba44-450e-bcf9-17058af00b76_3f4bd8f4-7124-4b69-a189-a03bd8ea7adf'
export const VectorArtBuilderID = '6a30caff-5dc3-4e4c-ba70-19db988f5830_4dbf752a-8a67-4149-87e7-6132bc25d3c2'
